var ResourceTypes;
(function (ResourceTypes) {
    ResourceTypes["ProviderConfigurations"] = "providerConfigurations";
    ResourceTypes["BusinessUnits"] = "businessUnits";
    ResourceTypes["SftpFolders"] = "sftpFolders";
})(ResourceTypes || (ResourceTypes = {}));
export default ResourceTypes;
